import { useState } from "react";
import { useSelector } from "react-redux";
import BreadcrumbNavigation from "components/ui/BreadcrumbNavigation";
import PersonalInformationSection from "./components/PersonalInformationSection";
import PasswordChangeSection from "./components/PasswordChangeSection";
import AccountSettingsSection from "./components/AccountSettingsSection";
import TabNavigation from "./components/TabNavigation";

const UserProfile = () => {
    const [activeTab, setActiveTab] = useState("personal");
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState({});
    const user = useSelector(state => state.auth.user);

    return (
        <div className="p-5">
            <div className="mb-6">
                <BreadcrumbNavigation />
                
                <div className="flex items-center justify-between mt-4">
                    <div>
                        <h1 className="text-2xl font-bold text-foreground">User Profile</h1>
                        <p className="text-muted-foreground mt-1">
                            Welcome to your profile page! Here you can view and edit your personal information, change your password, and manage your account settings.
                        </p>
                    </div>
                </div>
            </div>

            {/* Tab Navigation */}
            <div className="mb-6 border-b border-border">
                <TabNavigation
                    activeTab={activeTab}
                    onTabChange={setActiveTab}
                    hasUnsavedChanges={hasUnsavedChanges}
                />
            </div>
            
            {/* Tab Content */}
            <div className="max-w-2xl">
                {activeTab === "personal" && <PersonalInformationSection user={user} />}
                {activeTab === "password" && <PasswordChangeSection />}
                {activeTab === "settings" && <AccountSettingsSection user={user} />}
            </div>
        </div>
    );
};

export default UserProfile;